import React from 'react'

type Props = {}

export default function TokenSniper({}: Props) {
  return (
    <div><br></br><br></br><br></br><br></br><br></br><br></br>TokenSniper</div>
  )
}